import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ParkingDetailsComponent } from './parking-details/parking-details.component';
import { WaiverSummaryComponent } from './waiver-summary/waiver-summary.component';

const routes: Routes = [
    { path: 'waiver-summary', component: WaiverSummaryComponent },
    { path: 'parking-registraion/:token/:id', component: ParkingDetailsComponent },

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class ResidentRoutingModule { }
